import { render } from "./OnboardingScreenPanel.vue?vue&type=template&id=dfb1bc42&scoped=true"
import script from "./OnboardingScreenPanel.vue?vue&type=script&lang=js"
export * from "./OnboardingScreenPanel.vue?vue&type=script&lang=js"

import "./OnboardingScreenPanel.vue?vue&type=style&index=0&id=dfb1bc42&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfb1bc42"]])

export default __exports__